<template>
  <v-container class="acesso-user">
    <v-card
      class="py-4 px-2 auth-content"
      tile
      elevation="6"
    >
      <PageTitle
        main="Administração"
        icon="mdi-pencil-box-outline"
        sub="Views do sistema"
        home="/administracao"
      />
      <Form />
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Form from '../parametros/pageViews'
export default {
  name: 'PageViews',
  components: { PageTitle, Form },
  data: () => ({

  })
}
</script>
